// DataRouter.jsx
import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import Router from "./Router";

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="/*" element={<Router />} />)
);

export default function DataRouter() {
  return <RouterProvider router={router} />;
}
